const { getBranding } = require("./getBranding");

const lessGlobalVars = APP_THEME => {
	const branding = getBranding(APP_THEME);

	return {
		/**
		 * antd vars
		 */
		"@font-family": branding.fontFamily,

		"@primary-color": branding.colors.primaryColor,
		"@normal-color": branding.colors.textColor,
		"@link-color-bbranding.ack": "#3b4144",
		"@success-color": branding.colors.successColor,
		"@error-color": branding.colors.errorColor,
		"@warning-color": branding.colors.warningColor,

		"@body-background": branding.colors.backgroundColor,
		"@component-background": branding.colors.backgroundColor,
		"@text-color": branding.colors.textColor,
		"@text-color-secondary": branding.colors.textSecondaryColor,
		"@text-color-inverse": branding.colors.textInverseColor,
		"@heading-color": branding.colors.textColor,

		"@font-size-base": branding.fontSizes.baseFontSize,
		"@font-size-lg": branding.fontSizes.lgFontSize,
		"@font-size-sm": branding.fontSizes.smFontSize,
		//"@line-height-base": branding.fontSizes.babaseLineHeight, // @todo - this line give compile error

		"@border-radius-base": `${branding.spacing.smSpacing}px`,
		"@border-radius-sm": `${branding.spacing.xsSpacing}px`,

		"@padding-lg": `${branding.spacing.xlSpacing}px`,
		"@padding-md": `${branding.spacing.lgSpacing}px`,
		"@padding-sm": `${branding.spacing.mdSpacing}px`,
		"@padding-xs": `${branding.spacing.smSpacing}px`,
		"@padding-xss": `${branding.spacing.xsSpacing}px`,

		"@control-padding-horizontal": "@padding-sm",
		"@control-padding-horizontal-sm": "@padding-xs",

		"@margin-lg": `${branding.spacing.xlSpacing}px`,
		"@margin-md": `${branding.spacing.lgSpacing}px`,
		"@margin-sm": `${branding.spacing.mdSpacing}px`,
		"@margin-xs": `${branding.spacing.smSpacing}px`,
		"@margin-xss": `${branding.spacing.xsSpacing}px`,

		"@height-base": "40px",
		"@height-lg": "48px",
		"@height-sm": "32px",

		"@link-color": branding.colors.linkColor,
		"@link-hover-color": branding.colors.linkHoverColor,
		"@link-active-color": branding.colors.linkHoverColor,
		"@link-decoration": "none",
		"@link-hover-decoration": "none",
		"@link-focus-decoration": "none",
		"@link-focus-outline": 0,

		"@btn-font-weight": "bold",
		"@btn-primary-color": "#fff",
		"@btn-primary-bg": branding.colors.primaryColor,
		"@btn-border-radius-base": `${branding.spacing.smSpacing}px`,
		"@btn-border-radius-sm": "@border-radius-base",
		// nuestro secondary
		"@btn-default-ghost-color": "#fff",
		"@btn-default-ghost-bg": branding.colors.secondaryColor,
		"@btn-default-ghost-border": branding.colors.secondaryColor,

		"@checkbox-color": branding.colors.secondaryColor,

		"@divider-text-padding": "1em",
		"@divider-orientation-margin": "5%",

		"@dropdown-selected-color": branding.colors.primaryColor,
		"@dropdown-menu-submenu-disabled-bg": "@component-background",

		"@radio-dot-color": branding.colors.secondaryColor,

		"@radio-button-hover-color": branding.colors.secondaryHoverColor,
		"@radio-button-active-color": branding.colors.secondaryHoverColor,

		"@layout-body-background": "#FAFAFA",
		"@body-background": "#FAFAFA",
		"@layout-header-background": branding.colors.backgroundColor,
		"@layout-header-height": `${branding.headerHeight}px`,
		"@layout-header-padding": `0 ${branding.spacing.lgSpacing}px`,
		"@layout-footer-padding": `${branding.spacing.lgSpacing}px ${branding.spacing.lgSpacing}px`,
		"@layout-footer-background": "transparent",

		"@label-required-color": branding.colors.textSecondaryColor,
		"@label-color": branding.colors.textSecondaryColor,
		"@form-item-margin-bottom": `${branding.spacing.mdSpacing}px`,

		"@menu-dark-bg": branding.colors.backgroundMenuColor,
		"@tag-default-bg": branding.colors.backgroundColor,
		"@tag-default-color": "@text-color",
		"@tag-font-size": "@font-size-sm",
		"@tag-line-height": "24px",

		"@carousel-dot-width": `${branding.spacing.smSpacing}px`,
		"@carousel-dot-height": `${branding.spacing.smSpacing}px`,
		"@carousel-dot-active-width": `${branding.spacing.mdSpacing - 2}px`,

		"@tabs-card-active-color": branding.colors.secondaryColor,
		"@tabs-bar-margin": "0 0 0 0",
		"@tabs-horizontal-padding": "0 0",
		"@tabs-horizontal-padding-lg": "0 0",
		"@tabs-horizontal-padding-sm": "0 0",
		"@tabs-highlight-color": branding.colors.secondaryColor,
		"@tabs-hover-color": branding.colors.secondaryHoverColor,
		"@tabs-active-color": branding.colors.secondaryHoverColor,
		"@tabs-card-gutter": "0px",
		"@avatar-size-lg": "48px",
		"@switch-color": branding.colors.secondaryColor,

		/**
		 * Custom vars
		 */

		// colors
		"@primaryColor": branding.colors.primaryColor,
		"@primaryHoverColor": branding.colors.primaryHoverColor,
		"@primaryDarkColor": branding.colors.primaryDarkColor,
		"@secondaryColor": branding.colors.secondaryColor,
		"@secondaryHoverColor": branding.colors.secondaryHoverColor,
		"@secondaryOpacityColor": branding.colors.secondaryOpacityColor,
		"@textColor": branding.colors.textColor,
		"@textSecondaryColor": branding.colors.textSecondaryColor,
		"@textInverseColor": branding.colors.textInverseColor,
		"@backgroundColor": branding.colors.backgroundColor,
		"@backgroundModalColor": branding.colors.backgroundModalColor,
		"@backgroundMenuColor": branding.colors.backgroundMenuColor,
		"@linkColor": branding.colors.linkColor, // == secondaryColor
		"@linkHoverColor": branding.colors.linkHoverColor, // == secondaryHoverColor
		"@backgroundColorAternative": branding.colors.backgroundColorAternative,
		"@borderColor": branding.colors.borderColor,
		"@favoriteColor": branding.colors.favoriteColor,
		"@successColor": branding.colors.successColor,
		"@errorColor": branding.colors.errorColor,
		"@warningColor": branding.colors.warningColor,

		// font-sizes
		"@baseFontSize": branding.fontSizes.baseFontSize,
		"@baseLineHeight": `${branding.fontSizes.baseLineHeight}`,
		"@lgFontSize": branding.fontSizes.lgFontSize,
		"@smFontSize": branding.fontSizes.smFontSize,
		"@xsFontSize": branding.fontSizes.xsFontSize,
		"@xlTitle": branding.fontSizes.xlTitle,
		"@xlLineHeight": branding.fontSizes.xlLineHeight,
		"@lgTitle": branding.fontSizes.lgTitle,
		"@lgLineHeight": branding.fontSizes.lgLineHeight,
		"@lgTitle": branding.fontSizes.lgTitle,
		"@lgLineHeight": branding.fontSizes.lgLineHeight,
		"@mdTitle": branding.fontSizes.mdTitle,
		"@mdLineHeight": branding.fontSizes.mdLineHeight,
		"@mdTitle": branding.fontSizes.mdTitle,
		"@mdLineHeight": branding.fontSizes.mdLineHeight,
		"@smTitle": branding.fontSizes.smTitle,
		"@smLineHeight": branding.fontSizes.smLineHeight,
		"@smTitle": branding.fontSizes.smTitle,
		"@smLineHeight": branding.fontSizes.smLineHeight,
		"@xsTitle": branding.fontSizes.xsTitle,
		"@xsLineHeight": branding.fontSizes.xsLineHeight,

		// spacing
		"@xsSpacing": `${branding.spacing.xsSpacing}px`,
		"@smSpacing": `${branding.spacing.smSpacing}px`,
		"@mdSpacing": `${branding.spacing.mdSpacing}px`,
		"@lgSpacing": `${branding.spacing.lgSpacing}px`,
		"@xlSpacing": `${branding.spacing.xlSpacing}px`,
		"@xxlSpacing": `${branding.spacing.xxlSpacing}px`,

		"@breakpoint-xs": branding.breakPoints.xs,
		"@breakpoint-sm": branding.breakPoints.sm,
		"@breakpoint-md": branding.breakPoints.md,
		"@breakpoint-lg": branding.breakPoints.lg,
		"@breakpoint-xl": branding.breakPoints.xl,
		"@breakpoint-xxl": branding.breakPoints.xxl,

		// header height
		"@headerHeight": `${branding.headerHeight}px`,
	};
};

module.exports = { lessGlobalVars };
